import { render, staticRenderFns } from "./Template21.vue?vue&type=template&id=304eb9e2&scoped=true&"
import script from "./Template21.vue?vue&type=script&lang=js&"
export * from "./Template21.vue?vue&type=script&lang=js&"
import style0 from "./Template21.vue?vue&type=style&index=0&id=304eb9e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304eb9e2",
  null
  
)

export default component.exports